import { setMockPianoConfig } from 'services/Piano';
import PeopleRankingPage from 'pages/PeopleRanking/PeopleRankingPage';
import type { GetStaticProps } from 'next';
import getFranchiseListItem from 'api/FranchiseChildPage/getFranchiseListItem';
import setWellPageAdConfig from 'services/Ad/config/setWellPageAdConfig';
import { setHeadData } from 'utils/metaDataUtils/headData';
import type { FranchiseListItem } from 'interfaces/content/Ranking';
import setPageGtmConfig from 'services/Gtm/setPageGtmConfig';
import getFooter from 'api/Footer/getFooter';
import type { HeaderNav } from 'interfaces/navigation/Header';
import { wellLogo } from 'icons/WellLogo';
import handleStaticPropsError from 'utils/handleStaticPropsError';
import getMenu from 'api/Header/getMenu';
import { Microsites } from 'constants/constants';
import type { PreviewData } from 'interfaces/PreviewData';
import { safe, safeAsync } from 'utils/errorHandlingUtils';
import fallbackData from 'lib/fallbackData/commonData';

interface WellListDetailProps {
  franchiseListItem: FranchiseListItem;
}

const WellListDetail = ({ franchiseListItem }: WellListDetailProps) => (
  <PeopleRankingPage
    franchiseItem={franchiseListItem}
    trackingData={{
      eventAction: '',
      eventCategory: 'rankings',
      platformCD: Microsites.Well,
    }}
  />
);
export const getStaticProps: GetStaticProps = async (context) => {
  try {
    const footer = await safeAsync(() => getFooter(), fallbackData.footer);
    const menu: HeaderNav = await safeAsync(
      () => getMenu('LEFT_MENU_COM', 'RIGHT_MENU_COM', 'TOPIC_NAVIGATION_WELL', Microsites.Well, wellLogo),
      fallbackData.headerNav,
    );

    const { slug, year, id } = context.params as { slug: string; year: string; id: string };
    const { previewData } = context as { previewData: PreviewData };

    const { franchiseListItem } = await getFranchiseListItem(`/${slug}/${year}/${id}`, previewData, Microsites.Well);

    const pageAdConfig = safe(() => setWellPageAdConfig(franchiseListItem), fallbackData.pageAdConfig);
    const headData = safe(() => setHeadData(franchiseListItem, false, 'Fortune Well'), fallbackData.headData);
    const dataLayer = safe(
      () =>
        setPageGtmConfig({
          ...franchiseListItem,
          platformCD: Microsites.Well,
          title: franchiseListItem.listTitle,
        }),
      fallbackData.dataLayer,
    );

    return {
      props: {
        dataLayer,
        footer,
        franchiseListItem,
        headData,
        headerNav: menu,
        pageAdConfig,
        pianoPageConfig: setMockPianoConfig(),
      },
      revalidate: 60, // In seconds
    };
  } catch (e) {
    return handleStaticPropsError(e as Error);
  }
};

export const getStaticPaths = () => {
  if (process.env.TEST) {
    return {
      fallback: 'blocking',
      paths: [],
    };
  }

  const params = {
    id: 'ann-arbor',
    slug: 'best-places-families',
    year: '2022',
  };
  const paths = [{ params: { ...params } }];

  return {
    fallback: 'blocking',
    paths,
  };
};

export default WellListDetail;
